import { lazy } from 'react';
import { combineLoaders } from '@/lib/loader/combine-loader';
import { permissionsLoader } from '@/lib/loader/permission-loader';
import { FeatureFlagKey } from '@/features/feature-flag/feature-flag.constants';
import { withFeature } from '@/features/feature-flag/components/with-feature';

const DashboardV2Page = lazy(() => import('./pages'));

export const dashboardV2Route = [
  {
    path: '/dashboard-v2',
    Component: withFeature(FeatureFlagKey.MODULE_DASHBOARD, DashboardV2Page),
    loader: combineLoaders(permissionsLoader),
  },
];
